import React from 'react';
import { useNavigate, Link, useParams } from 'react-router-dom';
import Footer from './Footer';

const PartnerPage = () => {
    return (
        <>
            <header class="top-4 z-40 " style={{ marginTop: "10px" }}>
                <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div
                        class="bg-white/90 backdrop-blur ring-1 ring-black/5 rounded-[20px] md:rounded-[28px] px-3 sm:px-4 md:px-6">

                        <div class="flex items-center justify-between h-12">
                            <a href="" class="flex items-center gap-2">
                                <img src="assets/youvati_logo.png" alt="Youvati" class="w-auto" style={{ height: "2rem" }} />
                            </a>


                            <nav class="hidden md:flex items-center  text-sm" style={{ gap: "2.2rem", fontWeight: "600" }}>
                                <Link to="/" class="hover:text-[#7872F8]"  >Home</Link>
                                <Link to="/partnerpage" class="text-[#7872F8] px-2 py-0.5 rounded-lg bg-[#F0EFFE]">Partner with us</Link>
                                <Link to="/aboutus" class="hover:text-[#7872F8]" >About us</Link>
                                <Link to="/contactus" class="hover:text-[#7872F8]" >Contact us</Link>
                            </nav>


                            <a href="https://play.google.com/store/apps/details?id=com.empower.youvati&hl=en_IN"
                                target="_blank">
                                <div class="hidden md:flex items-center gap-2 rounded-xl border px-2.5 py-0.5 shadow-sm">
                                    <span class="font-bold text-sm">Download App</span>
                                    <img src="assets/arrow.png" alt="qr" class="h-6 w-6" />
                                </div>
                            </a>


                            <button id="menuBtn"
                                class="md:hidden inline-flex items-center justify-center rounded-xl border px-2 py-1"
                                aria-controls="mobileMenu" aria-expanded="false" aria-label="Open Menu">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                    class="w-5 h-5">
                                    <path fill-rule="evenodd"
                                        d="M3.75 5.25a.75.75 0 01.75-.75h15a.75.75 0 010 1.5h-15a.75.75 0 01-.75-.75zm0 6a.75.75 0 01.75-.75h15a.75.75 0 010 1.5h-15a.75.75 0 01-.75-.75zm0 6a.75.75 0 01.75-.75h15a.75.75 0 010 1.5h-15a.75.75 0 01-.75-.75z"
                                        clip-rule="evenodd" />
                                </svg>
                            </button>
                        </div>


                        <div id="mobileMenu" class="md:hidden hidden border-t border-black/5 pt-3 pb-3">
                            <nav class="flex flex-col gap-3 text-sm" style={{ fontWeight: "600" }}>
                                <a class="text-[#7872F8] px-2 py-1 rounded-lg bg-[#F0EFFE] w-max" href="#home">Home</a>
                                <a class="hover:text-[#7872F8]" href="#partners">Partner with us</a>
                                <a class="hover:text-[#7872F8]" href="#about">About us</a>
                                <a class="hover:text-[#7872F8]" href="#contact">Contact us</a>
                                <a class="inline-flex items-center gap-2 rounded-xl border px-3 py-2 w-max"
                                    href="https://play.google.com/store/apps/details?id=com.empower.youvati&hl=en_IN">
                                    <span class="font-bold">Download App</span>
                                    <img src="assets/arrow.png" class="h-6 w-6" />
                                </a>
                            </nav>
                        </div>
                    </div>
                </div>
            </header>

            <section className="partner-hero">
                <div className="text-section">
                    <h1 style={{ fontFamily: "syne" }}>
                        Join Hands With <br />
                        Youvati To <span className="highlight">Transform The Informal Economy</span> For Women.
                    </h1>
                    <p>
                        Explore diverse partnership pathways and choose what aligns with your goals to create meaningful, lasting impact, together.
                    </p>
                </div>
                <div className="image-section" style={{ display: "flex", justifyContent: "center" }}>
                    <img src="/assets/Frame3597.png" alt="Handshake Phone" />
                </div>
            </section>

            {/* <section className="partner-cards-grid">
                <div className="card soft-pink">
                    <img src="/assets/Frame3582.png" alt="Udhyogini App" />
                    <h2>Sponsor Youvati Udhyogini</h2>
                    <p>
                        Youvati’s partnership model for holistic digital and entrepreneurial empowerment. Sponsor subscriptions for women-led enterprises.
                    </p>
                    <button className="btn">Get Started ↗</button>
                </div>

                <div className="card soft-blue">
                    <img src="/assets/Frame358.png" alt="Donate" />
                    <h2>Donate To Srijan</h2>
                    <p>
                        Finance women-led businesses through Returnable Grants – 0% interest, credit access, and business growth via the Srijan Program.
                    </p>
                    <button className="btn">Learn More ↗</button>
                </div>


            </section> */}

            <section className="partner-cards-grid">
                {/* Card 1: Udhyogini */}
                <div className="card soft-pink">
                    <img src="/assets/Frame3582.png" alt="Udhyogini App" />
                    <div className="text-content">
                        <h2 style={{ fontFamily: "syne", fontSize: "" }}><strong>Sponsor Youvati Udhyogini</strong></h2>
                        <p>
                            Udhyogini is Youvati’s partnership model designed for holistic digital and entrepreneurial
                            empowerment of women-led enterprises. Sponsor Udhyogini subscriptions for women entrepreneurs
                            and self-employed aspiring businesswomen.
                        </p>
                    </div>
                    <Link to="/contactus"> <button className="styled-btn" style={{ height: "42px", marginTop: "1rem" }}>
                        Get Started
                        <span className="">
                            <img style={{ height: "22px" }} src="assets/arrow.png" alt="arrow" />
                        </span>
                    </button></Link>
                </div>

                {/* Card 2: Srijan */}
                <div className="card soft-blue">
                    <img src="/assets/Frame358.png" alt="Donate to Srijan" />
                    <div className="text-content">
                        <h2><strong>Donate To Srijan</strong></h2>
                        <p>
                            Help finance women-led businesses through Returnable Grants–collateral-free funding at 0% interest
                            which unlocks credit access and business growth. Donate to the Srijan Program, our credit
                            facilitation program implemented in association with Empower Foundation.
                        </p>
                    </div>
                    <Link to="/contactus"> <button className="styled-btn" style={{ height: "42px", marginTop: "1rem" }}>
                        Get Started
                        <span className="">
                            <img style={{ height: "22px" }} src="assets/arrow.png" alt="arrow" />
                        </span>
                    </button></Link>

                </div>
            </section>


            <section className="partner-cards-gridt" style={{ marginBottom: "2rem" }}>
                {/* Card 1: Udhyogini */}
                <div className="card soft-pink">
                    <img src="/assets/Frame35.png" alt="Udhyogini App" />
                    <div className="text-content">
                        <h2><strong>Sponsor Youvati Udhyogini</strong></h2>
                        <p>
                            Udhyogini is Youvati’s partnership model designed for holistic digital and entrepreneurial
                            empowerment of women-led enterprises. Sponsor Udhyogini subscriptions for women entrepreneurs
                            and self-employed aspiring businesswomen.
                        </p>
                    </div>

                    <Link to="/contactus"><button className="styled-btn" style={{ height: "42px", marginTop: "1rem" }}>
                        Get Started
                        <span className="">
                            <img style={{ height: "22px" }} src="assets/arrow.png" alt="arrow" />
                        </span>
                    </button></Link>
                </div>

                {/* Card 2: Srijan */}
                <div className="card soft-blue">
                    <img src="/assets/Frame582.png" alt="Donate to Srijan" />
                    <div className="text-content">
                        <h2><strong>Donate To Srijan</strong></h2>
                        <p>
                            Help finance women-led businesses through Returnable Grants–collateral-free funding at 0% interest
                            which unlocks credit access and business growth. Donate to the Srijan Program, our credit
                            facilitation program implemented in association with Empower Foundation.
                        </p>
                    </div>
                    <Link to="/contactus">
                        <button className="styled-btn" style={{ height: "42px", marginTop: "1rem" }}>
                            Get Started
                            <span className="">
                                <img style={{ height: "22px" }} src="assets/arrow.png" alt="arrow" />
                            </span>
                        </button>
                    </Link>

                </div>
            </section>


            <Footer />


            <style>
                {`
    
                
        body {
            margin: 0;
            font-family: Montserrat;
            color: var(--ink);
           background : #F6F5FA;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
        }

        .styled-btn {
  display: flex;
//   align-items: center;
  padding: 0.5rem 1.2rem;
  border: 2px solid #222;
  border-radius: 999px;
  font-size: 1rem;
  font-weight: 500;
  background-color: transparent;
  cursor: pointer;
  transition: all 0.3s ease;
  gap: 0.5rem;
}

.circle-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #222;
  border-radius: 50%;
  width: 2rem;
  height: 2rem;
}

.icon-img {
  width: 1rem;
  height: 1rem;
  filter: invert(1); /* make white if it's a black arrow */
}


.partner-hero {
  display: flex;
  padding: 3rem 5%;
//   background-color: #f6f2fe;
  align-items: center;
  justify-content: space-between;
}

.partner-hero .text-section,
.partner-hero .image-section {
  flex: 1;
  width: 50%;
}

.partner-hero .text-section {
  padding-right: 2rem;
}

.partner-hero .image-section img {
  width: 82%;
  max-width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
}


.partner-hero .text-section h1 {
  font-size: 2.2rem;
  font-weight: bold;
}

.partner-hero .text-section .highlight {
  color: #8874ff;
}

.partner-hero img {
  width: 100%;
  max-width: 400px;
}

.partner-cards-grid {
  display: grid;
   grid-template-columns: 40% 60%;
  gap: 2rem;
  padding: 3rem 5%;
}

.partner-cards-gridt {
  display: grid;
   grid-template-columns: 60% 40%;
  gap: 2rem;
  padding: 0rem 5%;
}

.card {
  padding: 1.5rem;
  border-radius: 16px;
  background: #fafafa;
  text-align: left;
}

.card img {
  width: 100%;
  border-radius: 12px;
  margin-bottom: 1rem;
}

.btn {
  background-color: #8874ff;
  color: white;
  padding: 0.6rem 1.2rem;
  border-radius: 12px;
  margin-top: 1rem;
  border: none;
  cursor: pointer;
  font-size: 0.9rem;
}



/* ------------------- MOBILE RESPONSIVE FIX ------------------- */
@media (max-width: 768px) {

  /* HERO SECTION */
  .partner-hero {
    flex-direction: column;
    text-align: center;
    padding: 2rem 1.2rem;
  }

  .partner-hero .text-section {
    width: 100%;
    padding-right: 0;
    margin-bottom: 1.5rem;
  }

  .partner-hero .text-section h1 {
    font-size: 1.6rem;
    line-height: 1.3;
  }

  .partner-hero .image-section {
    width: 100%;
  }

  .partner-hero .image-section img {
    width: 90%;
  }


  /* CARD GRID STACKS ON MOBILE */
  .partner-cards-grid,
  .partner-cards-gridt {
    grid-template-columns: 1fr !important;
    padding: 1.5rem 1rem;
    gap: 1.2rem;
  }

  .card {
    padding: 1.2rem;
  }

  .card img {
    width: 100%;
    margin-bottom: 1rem;
  }

  .styled-btn {
    width: 100%;
    justify-content: center;
  }

  /* MOBILE NAV FIX */
  header {
    margin-top: 0 !important;
  }

  #mobileMenu nav a {
    width: 100%;
  }
}


    `}
            </style>
        </>
    );
};

export default PartnerPage;
